<template>
    <overlay-modal ref="overlayModal" height="60%">
        <template v-slot:header>
            <h4 class="cursive">Date flessibili</h4>
            <p class="m-0">Valuta le altre date di partenza e trova la soluzione alle tue esigenze di viaggio</p>
        </template>
        <template>
            <div class="modal-flexible-date container">
                <div class="text-center">
                    <div class="alert alert-danger">
                        <p class="mb-0"><b>Attenzione!</b> Se si seleziona un nuovo range di date l'itinerario sarà cancellato</p>
                    </div>
                    <div class="items">
                        <div :class="item.selected? 'item selected' : 'item'" v-for="(item, index) in list" :key="index" :value="item" class="item" @click="onSelect(item)">
                            <div>
                                <h3 v-if="!item.selected" :class="makeDeltaPrice(item.prezzoVendita)>0 ? 'more' : 'minus'">{{sign(item.prezzoVendita)}}{{abs(item.prezzoVendita)}} &euro;</h3>
                                <h3 v-else>Date selezionate</h3>
                            </div>
                            <div class="d-flex justify-content-around">
                                <div>
                                    <span>{{getDayExtended(item.start)}}</span>
                                    <h2>{{getDay(item.start)}}</h2>
                                    <span>{{getMonth(item.start)}}</span>
                                </div>
                                <div>
                                    <span>{{getDayExtended(item.end)}}</span>
                                    <h2>{{getDay(item.end)}}</h2>
                                    <span>{{getMonth(item.end)}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {getDay, getDayExtended, getMonth} from '../../../../../utils/formatter'
import OverlayModal from '../../../../modals/OverlayModal'
import {ERROR_SEARCH_NO_FLIGHT} from '../../../../../utils/messages'
import SearchVoloHotelAction from '../../../../actions/SearchVoloHotelAction'

export default {
  mixins: [SearchVoloHotelAction],
  methods: {
    ...mapGetters(['getFlexibleDates', 'getSearch', 'getFlightFrom']),
    ...mapActions(['loadFlights', 'loadFlexibleDates', 'loadHotels', 'loadServizi', 'loadTrasferimenti', 'addSearch', 'loadingStart', 'loadingEnd']),
    getDay,
    getDayExtended,
    getMonth,
    open: function () {
      this.$refs.overlayModal.open()
    },
    close: function () {
      this.$refs.overlayModal.close()
    },
    makeDeltaPrice: function (price) {
      return Math.round(price - this.getFlightFrom().prezzoVendita)
    },
    abs: function (price) {
      return Math.abs(this.makeDeltaPrice(price))
    },
    sign: function (price) {
      return this.makeDeltaPrice(price) > 0 ? '+' : '-'
    },
    onSelect: function (item) {
      const search = this.getSearch()
      const payload = {
        aereoporto: search.aereoporto,
        andata: item.start,
        ritorno: item.end,
        camere: search.camere
      }
      this.close()
      this.loadingStart()
      this.searchVoloHotel(payload).then((response) => {
        const {flightVectorGroups, periodFlights, periodHotels, periodServizi} = response.data.object
        if (flightVectorGroups) this.loadFlights(flightVectorGroups)
        else {
          this.$toastr.error(ERROR_SEARCH_NO_FLIGHT)
          return
        }
        if (periodFlights) this.loadFlexibleDates(periodFlights)
        if (periodHotels) this.loadHotels(periodHotels)
        if (periodServizi) {
          this.loadServizi(periodServizi)
          this.loadTrasferimenti(periodServizi)
        }
        this.addSearch(this.search)
      }).catch((error) => {
        if (error.messages) {
          error.messages.map((item) => {
            this.$toastr.error(item.message)
          })
        } else {
          this.$toastr.error('Generic error!')
        }
      }).finally(() => {
        this.loadingEnd()
      })
    }
  },
  name: 'ModalFlexibleDates',
  components: {OverlayModal},
  computed: {
    search: function () {
      return this.getSearch()
    },
    list: function () {
      let dates = [...this.getFlexibleDates()]
      const search = this.getSearch()
      const prezzoVendita = this.getFlightFrom().prezzoVendita
      dates.push({selected: true, start: search.andata, end: search.ritorno, prezzoVendita})
      return dates.sort(function (a, b) {
        return a.start.getTime() > b.start.getTime()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/modals/ModalFlexibleDates.vue